import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { helpHttp } from "../../helpers/helpHttp";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { BASE_API, LABELTEXT, LABELTEXT_S } from "../../api/Globals";
// import useScanDetection from "use-scan-detection";
import { Toast } from 'primereact/toast';
import { Image } from 'primereact/image';
import { FileUpload } from 'primereact/fileupload'
import CustomSelect from '../../components/select/CustomSelect';
import ScannerEntrega from "../../pages/entrega/barcode";
import { storage } from "../../helpers/storage";

const emptyArr = { serie: '' };

const FolioTablet = (
    {
        visible = false,
        rowData = [],
        onHide = () => { },
        abreAlta = () => { }
    }
) => {
    const [dataFolio, setDataFolio] = useState([]);
    const [selectedTablets, setSelectedTablets] = useState([])
    const [tablet, setTablet] = useState(emptyArr);
    const [numTabletas, setNumTabletas] = useState(0);
    const idPerfil = storage.get('perfilid');
    const [scannerDialog, setScannerDialog] = useState(false);
    const [image1, setImage1] = useState('')
    const [image2, setImage2] = useState('')
    const [image3, setImage3] = useState('')

    const [loading1, setLoading1] = useState(false)

    const toast = useRef(null);

    // useScanDetection({
    //     onComplete: (code) => { setTablet({ ...tablet, serie: code }) },
    // })

    useEffect(() => {
        console.log(dataFolio)
    }, [dataFolio])

    useEffect(() => {
        if (visible !== false) {
            if (rowData.length !== 0) {
                const url = (`${BASE_API}Tablets/postSpdAlmObtenerTabletsXFolioMov`);
                helpHttp().post(url, {
                    body: {
                        idUsuario: storage.get('id'),
                        idEstatus: rowData.IdEstatus,
                        FolioMov: rowData.FolioTransferencia,
                        parametrosExtra: ""
                    },
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                }).then(res => {
                    if (res.SUCCES !== false) {
                        if (storage.get('perfilid') !== "1") {
                            formatTable(res.ITEMS)
                        } else {
                            let array = res.ITEMS.map(x => {
                                let item = {
                                    label: x.serie,
                                    value: { ...x }
                                }
                                return item
                            })
                            setDataFolio(res.ITEMS);
                        }

                    }
                })
            }
        }
    }, [visible]);

    const seleccionarTabletas = (e) => {
        e.preventDefault()
        if (dataFolio.length !== 0) {
            const arr = dataFolio
            const res = dataFolio.find(item => item.value.serie === tablet.serie);
            if (res !== undefined) {
                let arrSel = selectedTablets
                const index = arr.indexOf(res);
                const x = arr.splice(index, 1)

                arrSel.push(x[0].value)
                setDataFolio(arr)
                setSelectedTablets(arrSel)
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `La ${LABELTEXT.toLowerCase()} no se encuentra en este almacén.`, life: 5000 })
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Ya no hay ${LABELTEXT.toLowerCase()} en el por escanear.`, life: 3000 });
        }
        setTablet(emptyArr)
    }

    const seleccionarTabletasQR = (serie) => {
        if (dataFolio.length !== 0) {
            const arr = dataFolio
            const res = dataFolio.find(item => item.value.serie === serie);
            if (res !== undefined) {
                let arrSel = selectedTablets
                const index = arr.indexOf(res);
                const x = arr.splice(index, 1)

                arrSel.push(x[0].value)
                setDataFolio(arr)
                setSelectedTablets(arrSel)
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `La ${LABELTEXT.toLowerCase()} no se encuentra en este almacén.`, life: 5000 })
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Ya no hay ${LABELTEXT.toLowerCase()} en el por escanear.`, life: 3000 });
        }
        setTablet(emptyArr)
    }

    // const removerTableta = (data) => {
    //     if (selectedTablets.length !== 0) {
    //         const arrSel = selectedTablets
    //         const res = selectedTablets.find(item => item.serie === data.serie);
    //         if (res !== undefined) {
    //             let arr = dataFolio
    //             const index = arrSel.indexOf(res);
    //             const x = arrSel.splice(index, 1)

    //             const option = {
    //                 label: x[0].serie,
    //                 value: { ...x[0] }
    //             }
    //             arr.push(option)
    //             setDataFolio(arr)
    //             setSelectedTablets(arrSel)
    //             console.log(3333)
    //             console.log(arrSel)
    //         } else {
    //             toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "La tableta no se encuentra en este almacén.", life: 5000 })
    //         }
    //     } else {
    //         toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Ya no hay tabletas en el por escanear.', life: 3000 });
    //     }
    // }

    const removerTableta2 = (data) => {
        if (selectedTablets.length !== 0) {
            const arr = dataFolio
            const res = selectedTablets.filter(item => item.serie !== data.serie);
            if (res !== undefined) {

                const option = {
                    label: data.serie,
                    value: { ...data }
                }
                console.log(option)
                arr.push(option)

                setDataFolio(arr)

                setSelectedTablets(res)
            }
            else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `La ${LABELTEXT.toLowerCase()} no se encuentra en este almacén.`, life: 5000 })
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Ya no hay ${LABELTEXT.toLowerCase()} en el por escanear.`, life: 3000 });
        }
    }

    const formatTable = async (lstData) => {
        const res = lstData.map(e => {
            let item = {
                label: e.serie,
                value: {
                    ...e,
                    IdEstatusAlmacen: 2
                }
            }
            return item;
        });
        setNumTabletas(res.length)
        setDataFolio(res);
        // setSelectedTablets(res);
    }

    const onHideFolio = () => {
        setSelectedTablets([])
        onHide();
    }

    const TranferirTabletas = () => {
        console.log('carga TranferirTabletas')

        if (selectedTablets.length !== 0) {
            if (image1 !== '' && image2 !== '' && image3 !== '') {
                setLoading1(true)
                const url = (`${BASE_API}Tablets/postspdAlmAsignarTabletMasiva`)
                helpHttp().post(url, {
                    body: {
                        opcion: 'E',
                        id_EncAlmacen: null,
                        id_Estatus: 2,
                        id_TareaDetAlmacen: 1,
                        TablaTablets: selectedTablets,
                        NotificaciondeEjecucion: ""
                    },
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                }).then(res => {
                    if (res.SUCCES !== false) {
                        GuardarDocumento(JSON.parse(res.ITEMS.NotificacionEjecucion))
                        console.log(res)
                    }
                })
            }
        }
    }



    const GuardarDocumento = (_NotificaciondeEjecucion2) => {
        console.log(_NotificaciondeEjecucion2)
        const url = (`${BASE_API}Tablets/postSpdAlmAgregarDocumento`)
        helpHttp().post(url, {
            body: {
                "tiendaOrigen": storage.get('IdTienda'),
                "UsuarioOrigen": storage.get('usuario'),
                "IdUsuarioCreacion": storage.get('id'),
                "IdUsuarioModificacion": 0,
                "Ruta": "",
                "Folio": _NotificaciondeEjecucion2.FolioMov,
                "Formato": "",
                "ParametroExtras": "",
                "FotoFrente": image1.split(',')[1],
                "FotoReverso": image2.split(',')[1],
                "FotoFirma": image3.split(',')[1]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCES !== false) {
                onHideFolio();
                console.log(res)
            }
            setLoading1(false)
        })
    }



    const tabletDialogFooter = (
        <React.Fragment>
            {idPerfil !== "1" ?
                <>
                    <Button label="Guardar" icon="pi pi-check" loading={loading1} className="p-button" onClick={() => TranferirTabletas()} />
                    <Button label="Cancelar" icon="pi pi-times" disabled={loading1} className="p-button-outlined" onClick={() => onHideFolio()} />
                </> :
                <>
                    <Button label="Cerrar" icon="pi pi-times" className="p-button-outlined" onClick={() => onHideFolio()} />
                    <Button label="Imprimir" icon="pi pi-print" className="p-button" onClick={() => ' '} />
                </>
            }
        </React.Fragment>
    );

    const saveImageHandler = async (e, option) => {
        const reader = new FileReader();
        reader.readAsDataURL(e.files[0]);
        reader.onload = (e) => {
            switch (option) {
                case 1:
                    setImage1(e.target.result);
                    break;
                case 2:
                    setImage2(e.target.result);
                    break;
                case 3:
                    setImage3(e.target.result);
                    break;
            }
        }
    }

    const retiroBodyTemplate = (rowData) => {
        return (
            <div className="text-center">
                <Button className="p-button" rounded icon='pi pi-trash' tooltip={`Remover ${LABELTEXT_S.toLowerCase()}`} onClick={() => removerTableta2(rowData)} />
            </div>
        )
    }
    const scannerFooterTemplate = () => {
        return(
            <div className="flex justify-content-end">
                <Button className="p-button-outlined" label='Cancelar' icon='pi pi-times' onClick={() => setScannerDialog(!scannerDialog)} />
            </div>
        )
    }


    return (
        <>
            <Dialog visible={visible} closable={false} style={{ width: '80% ' }} draggable={false} footer={tabletDialogFooter}
                header={
                    <div className="grid" style={{ alignItems: 'center', backgroundColor: '#9b2f3e', color: "white" }}>
                        <div className="col-4" style={{ textAlign: 'left', paddingLeft: '20px', fontSize: '14px', fontWeight: 'lighter' }}><i className='pi pi-tag mr-2'></i>Folio {rowData.FolioTransferencia}</div>
                        <div className="col-4"> GESTIÓN DE FOLIO</div>
                        <div className="col-4"><i style={{ float: 'right', color: '#fff', cursor: 'pointer', fontSize: '25px' }} onClick={onHideFolio} className="pi pi-times-circle"></i></div>
                    </div>
                }>
                <Toast ref={toast} />
                <div className="grid">
                    <div className="col-12 m-3">
                        <form onSubmit={seleccionarTabletas}>
                            <div className="md:flex lg:flex">
                                <CustomSelect
                                    className='w-full md:w-11 lg:w-11'
                                    autofocus
                                    id={'serie'}
                                    defaultValue={''}
                                    placeholder={`Buscar ${LABELTEXT_S.toLowerCase()}`}
                                    noOptionsMessage={'No se encontraron incidencias.'}
                                    options={dataFolio}
                                    value={tablet.serie}
                                    onChange={(value) => { setTablet({ ...tablet, serie: value.value.serie }) }} />
                                <Button type="submit" label="Agregar" icon='pi pi-plus' className="p-button w-full mt-3 md:w-auto lg:w-auto md:ml-3 lg:ml-3 md:mt-0 lg:mt-0" />
                                <Button type="button" label="Escaner" icon='pi pi-qrcode' className="p-button w-full mt-3 md:w-auto lg:w-auto md:ml-3 lg:ml-3 md:mt-0 lg:mt-0" onClick={() => setScannerDialog(true)} />
                            </div>
                        </form>
                    </div>
                    {(seleccionarTabletas !== null) &&
                        <div className="col-12">
                            <div className="flex-auto">
                                <h5>{`${LABELTEXT} por recibir: ${numTabletas}`}</h5>
                                <h5>{`${LABELTEXT} escaneadas: ${selectedTablets.length}`}</h5>
                            </div>
                            <DataTable value={selectedTablets} showGridlines
                                emptyMessage={<label>{`Favor de escaear ${LABELTEXT.toLowerCase()}`}</label>}
                                paginator rows={20}
                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                currentPageReportTemplate="Mostrando del {first} hasta {last} de {totalRecords}">
                                <Column field="IdAlmacen" header='Código' />
                                <Column field="serie" header='Serie' />
                                <Column header="Remover" body={retiroBodyTemplate} />
                            </DataTable>
                        </div>}
                    <div className="col-12">
                        <h5>Evidencias:</h5>
                        <div className="grid">
                            <div className="col-12 mt-5 text-center" style={{ borderStyle: 'solid', borderColor: 'black', borderRadius: '1rem' }}>
                                {image1 !== '' ? <Image src={image1} alt="Image" width="250" preview /> :
                                    <div style={{ textAlign: 'center' }}>
                                        <i className="pi pi-camera" style={{ fontSize: '200px' }} />
                                    </div>}
                                <div className="mt-3 mb-3">
                                    <FileUpload mode="basic" accept="image/*" maxFileSize={1000000}
                                        uploadHandler={(e) => { saveImageHandler(e, 1) }} auto chooseLabel='Identificaión Frontal' customUpload={true} />
                                </div>
                            </div>
                            <div className="col-12 mt-5 text-center" style={{ borderStyle: 'solid', borderColor: 'black', borderRadius: '1rem' }}>
                                {image2 !== '' ? <Image src={image2} alt="Image" width="250" preview /> :
                                    <div style={{ textAlign: 'center' }}>
                                        <i className="pi pi-camera" style={{ fontSize: '200px' }} />
                                    </div>
                                }
                                <div className="mt-3 mb-3">
                                    <FileUpload mode="basic" accept="image/*" maxFileSize={1000000}
                                        uploadHandler={(e) => { saveImageHandler(e, 2) }} auto chooseLabel='Identificación trasera' customUpload={true} />
                                </div>
                            </div>
                            <div className="col-12 mt-5 text-center" style={{ borderStyle: 'solid', borderColor: 'black', borderRadius: '1rem' }}>
                                {image3 !== '' ? <Image src={image3} alt="Image" width="250" preview /> :
                                    <div style={{ textAlign: 'center' }}>
                                        <i className="pi pi-camera" style={{ fontSize: '200px' }} />
                                    </div>
                                }
                                <div className="mt-3 mb-3">
                                    <FileUpload mode="basic" accept="image/*" maxFileSize={1000000}
                                        uploadHandler={(e) => { saveImageHandler(e, 3) }} auto chooseLabel='Identificación trasera' customUpload={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            <Dialog header='ESCANER' visible={scannerDialog} style={{ width: "40%" }} closable={false} draggable={false} footer={scannerFooterTemplate} >
                <ScannerEntrega alumnoRow={{ IdAlumno: -1 }} onResult={(e) => { seleccionarTabletasQR(e.Serie) }} onHide={() => setScannerDialog(!scannerDialog)} />
            </Dialog>
        </>
    )
}

export default FolioTablet;